import { useQuery } from "@tanstack/react-query";
import { fetchTrends } from "../lib/api";
const QUERY_KEY = ["trends", "global"];
export function useTrendsQuery() {
    const queryFn = () => fetchTrends({ offset: 0, limit: 60 });
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn,
        gcTime: 60000
    });
}
